export const LOCATION_STYLES = {
  bar: { dot: "bg-amber-400", active: "bg-amber-500 text-[#0D0E12]", text: "text-amber-400" },
  reserve_bar: { dot: "bg-blue-400", active: "bg-blue-500 text-white", text: "text-blue-400" },
  local_fut: { dot: "bg-emerald-400", active: "bg-emerald-500 text-[#0D0E12]", text: "text-emerald-400" },
  quai_livraison: { dot: "bg-purple-400", active: "bg-purple-500 text-white", text: "text-purple-400" },
  niveau_moins_1: { dot: "bg-pink-400", active: "bg-pink-500 text-white", text: "text-pink-400" },
  cuisine: { dot: "bg-orange-400", active: "bg-orange-500 text-[#0D0E12]", text: "text-orange-400" },
};

export const locStyle = (id) =>
  LOCATION_STYLES[id] || { dot: "bg-slate-400", active: "bg-slate-500 text-white", text: "text-slate-400" };

export const SECTOR_META = {
  bar: { label: "Bar", accent: "text-amber-400", ring: "ring-amber-500/40", bg: "from-amber-500/20" },
  cuisine: { label: "Cuisine", accent: "text-orange-400", ring: "ring-orange-500/40", bg: "from-orange-500/20" },
};

export const slug = (s) =>
  (s || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
